import { Component, Input, Output, EventEmitter } from "@angular/core"

@Component({
    selector: "app-school-selector",
    templateUrl: "./school-selector.component.html",
    styleUrls: ["./school-selector.component.less"],
})
export class SchoolSelectorComponent {
    @Input() public linkLabel?: string = ""
    @Input() public linkTarget?: string = ""
    @Input() public items: Array<any>
    @Input() public selectedItem: any
    @Output() public selectedItemChange = new EventEmitter<any>()
}
